import { ReactComponent as IconSearch } from '@/assets/svgs/icon-search.svg'
import { assetUrl } from '@/utils/asset-url'
import CardSystem from '@/components/CardSystem'
import InputSuffixIcon from '@/components/InputSuffixIcon'
import Portal from '@/components/Portal'
import Tabs, { Tab } from '@/components/Tabs'
import Toast from '@/components/Toast'
import { featureConstant } from '@/constants/configuration/feature'
import usePage from '@/hooks/use-page'
import useStatus from '@/hooks/use-status'
import useToast from '@/hooks/use-toast'
import { useParams } from '@/lib/router-dom'
import { feature } from '@/utils/feature-verifier'
import rem from '@/utils/rem'
import { getUseCaseId } from "@/utils/use-case-storage"
import { orderBy } from 'lodash'
import moment from 'moment'
import { useEffect, useMemo, useRef, useState } from 'react'
import Search from '@/componentsDS/Search/index';
import Tags from '@/componentsDS/Tags/Tags';
import Breadcrumbs from '@/componentsDS/Breadcrumbs/index'


const Page = () => {

	/*=================================================
		General
	/================================================*/


	const { useCaseId } = useParams()
	const useCase = useMemo(() => getUseCaseId(useCaseId), [useCaseId]);

	const toastType = {
		success: "success",
		error: "error"
	}

	const [pageTitle, setPageTitle] = useState('System Monitoring')
	const [subPageTitle, setSubPageTitle] = useState(useCase.name)

	const { breadcrumbsItems } = usePage({
		title: pageTitle,
		breadcrumbs:  [
			{
				label:'',
				link:'/'
			},
			{
				label:'Use Cases',
				link:'/use-cases/enrolment'
			},
			{
				label: subPageTitle,
				link: `/use-cases/${useCaseId}/dashboard`
			},
			{
				label: pageTitle,
				link: ``
			},
		]
	 })

	/*=================================================
		API
	/================================================*/

	const { toastList, addToastMessage } = useToast()

	const { fetchMyPitstops, myPitstops, error } = useStatus()
	const items = myPitstops;
	useEffect(() => {

		async function getData() {
			fetchMyPitstops()
		}

		getData()
	}, [])

	useEffect(()=>{
		addToastMessage(error, toastType.error)
	}, [error])

	/*=================================================
		Filter Popup
	/================================================*/
	const referenceRef = useRef(null)

	useEffect(() => {
		document.addEventListener('mousedown', handleDocumentClick)
		return () => {
			document.removeEventListener('mousedown', handleDocumentClick)
		}
	}, [])

	function handleDocumentClick(event) {

		if (!referenceRef.current) {
			return
		}

		if (referenceRef.current.contains(event.target)) {
			return
		}
	}
	/*=================================================
		Provide Options
	/================================================*/

	const [filteredSystems, setFilteredSystems] = useState([])
	const [searchSystems, setSearchSystems] = useState()

	useEffect(() => {

		if (!items) {
			return
		}

		if (!searchSystems) {

			const sortedItems = orderBy(items, ['name'], ['asc'])

			return setFilteredSystems(sortedItems)
		}

		const sortedItems = orderBy(items, ['name'], ['asc'])
		const updatedSystems = sortedItems
		.filter(item => item.name.toLowerCase().includes(searchSystems?.toLowerCase()))

		setFilteredSystems(updatedSystems)
	}, [searchSystems, items])


	/*=================================================
		Tabs
	/================================================*/

	const [tabsItems, setTabsItems] = useState([
		{ label: 'System Monitoring', active: true, options: ['system-monitoring'] },
	])

	function selectTab(index) {

		const items = [...tabsItems].map(item => ({ ...item, active: false }))

		items[index].active = true

		setTabsItems(items)
	}


	/*=================================================
		Routes
	/================================================*/


	return (
		<>
			<Breadcrumbs breadcrumbItems={breadcrumbsItems} />

			{/* <div className="title-header__back" onClick={() => goBack(useCaseId)}>
				<div className=""><IconPrevious /></div>
				<div className="title-header__back__text link">Back</div>
			</div> */}

			<div className="title-header">
				<div className="title-header__left">
					<div className="title-header__title">{pageTitle}</div>
				</div>
				<div className="title-header__right">
				</div>
			</div>

			<Tabs>
				{tabsItems.map((item, index) => (
					<Tab key={index} label={item.label} active={item.active} onClick={() => selectTab(index)} />
				))}
			</Tabs>

			<div style={{ height: rem(43) }}></div>

			<div style={{ display: 'flex' }}>
				{
					feature(featureConstant.NEW_DESIGN_SYSTEM) ? (
						<div>

							<Search
							placeholder="Search by Name"
							value={searchSystems || ''} onChange={(e) => setSearchSystems(e.target.value)} onCancel={() => setSearchSystems('')}
							/>
						</div>
					):(
						<InputSuffixIcon maxWidth="221" placeholder="Search by Name" className="input--grey" icon={<IconSearch />} value={searchSystems || ''} onChange={(e) => setSearchSystems(e.target.value)} />
					)
				}

				<div style={{ width: rem(10) }}></div>
			</div>

			<div style={{ height: rem(43) }}></div>

			<div className="grid-system">
				<div className="grid-system__cols">
					{filteredSystems.map((item, index) => {

						return (
							<div className="grid-system__col" key={index}>
								<CardSystem>
									<CardSystem.Avatar>
										<img src={item.image} alt="" />
									</CardSystem.Avatar>
									<CardSystem.Title>{item.name}</CardSystem.Title>
									<CardSystem.Subtitle>
										{moment(new Date()).format('DD MMM YYYY h:mmA')}
									</CardSystem.Subtitle>
								</CardSystem>
							</div>
						)
					})}
				</div>
			</div>

			<Toast toastList={toastList}  />
		</>
	)
}

export default Page
